import React from 'react'
import { compose } from 'recompose'
import { lpForm } from 'lp-form'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { ToggleCheckbox, SectionBlock, SectionHeader } from 'components'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { camelCase } from 'lodash'

const propTypes = {
  ...formPropTypes,
  badges: PropTypes.arrayOf(Types.badge),
}

const defaultProps = {
  badges: [],
}

function ArtistQuestionForm({ handleSubmit, badges }) {
  const visibleBadges = (badges || []).filter(
    (badge) => badge.visibleInUserPortal
  )

  if (visibleBadges.length === 0) return null

  return (
    <SectionBlock>
      <SectionHeader>
        <h2 id="badge-details">Badges</h2>
      </SectionHeader>
      <form onSubmit={handleSubmit} noValidate>
        <div className="badge-questions-section">
          {visibleBadges.map((badge) => {
            const labelId = `badge-${badge.name}-label`
            const descriptionId = `badge-${badge.name}-description`

            return (
              <div key={`badge-${badge.id || badge.name}`}>
                <label id={labelId} htmlFor={`badge-toggle-${badge.name}`}>
                  {badge.questionText}
                </label>
                <Field
                  id={`badge-toggle-${badge.name}`}
                  name={camelCase(badge.name)}
                  component={ToggleCheckbox}
                  label={false}
                  ariaLabelledby={labelId}
                  ariaDescribedby={descriptionId}
                  className="toggle-checkbox"
                  onChange={() => setTimeout(handleSubmit, 0)}
                />
              </div>
            )
          })}
        </div>
      </form>
    </SectionBlock>
  )
}

ArtistQuestionForm.propTypes = propTypes
ArtistQuestionForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'artist-question',
  })
)(ArtistQuestionForm)
